import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userCenter6",
  "use": "icon-userCenter6-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-userCenter6\"><g fill=\"none\" fill-rule=\"nonzero\"><path d=\"M43.5 43.5H.5V.5h43v43zm-3-40h-37v37h37v-37z\" fill=\"#062337\" /><path fill=\"#2F54EB\" d=\"M11.01 27.723l6.832-5.138 5.765 6.876 11.455-9.23-2.51-3.115-8.4 6.77-5.682-6.777-9.865 7.417z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol